import styled from 'styled-components';
import { Typography } from '../../../ui/Typography';

export const ResidenceName = styled(Typography)`
  display: block;
  margin-bottom: 10px;
`;

export const ResidenceCardWrapper = styled.div`
  &:not(:last-of-type) {
    margin-bottom: 20px;
  }
`;
